module.exports = __webpack_public_path__ + "static/media/f9e33d8f-e541-4a01-8326-140f16071ecf.0ef30d51.jpeg";